import { render, staticRenderFns } from "./BaseView.vue.html?vue&type=template&id=33ab5cbe&scoped=true&"
import script from "./BaseView.component.js?vue&type=script&lang=vueJs&"
export * from "./BaseView.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BaseView.scoped.scss?vue&type=style&index=0&id=33ab5cbe&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab5cbe",
  null
  
)

export default component.exports